

















import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import AvailabilityHoursForm from '@ui/Calendar/AvailabilityHoursForm'

settings =
  name: 'VenueAvailabilityWindowStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      AvailabilityHoursForm,
    }

    data: ->
      audienceAvailability: @wizard.selectedAudienceAvailability
      calendar: @wizard.selectedCalendar

export default VueOptions.vue settings
